/*
  rx-regalo.js · Regalo con packs.
  Mantiene en el carrito 1 regalo por pedido cuando hay la cantidad mínima del
  producto de la promo, y lo saca si baja de esa cantidad. La configuración sale
  del snippet rx-regalo (Configuración del tema > RX · Regalo con packs).
  El regalo se vende a $0 (con su valor como precio de comparación), así que CUALQUIER
  línea del producto de regalo cuenta como regalo, aunque no la haya agregado el tema:
  sin los llaveros mínimos se saca, y nunca queda más de 1.
  En el carrito se muestra con el valor tachado y "Gratis".
*/
(function () {
  var nodo = document.getElementById('rx-regalo-config');
  if (!nodo || window.RxRegalo) return;

  var cfg;
  try { cfg = JSON.parse(nodo.textContent); } catch (e) { return; }

  var raizTienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esRegalo(item) {
    return item.product_id === cfg.producto;
  }

  function contarLlaveros(cart) {
    var n = 0;
    cart.items.forEach(function (i) {
      if (i.product_id === cfg.compra && !esRegalo(i)) n += i.quantity;
    });
    return n;
  }

  function califica(cantidad) {
    return cfg.disponible && cantidad >= cfg.minimo;
  }

  function lineaRegalo() {
    var props = {};
    props[cfg.propiedad] = cfg.nota;
    return { id: cfg.variante, quantity: 1, properties: props };
  }

  function post(ruta, cuerpo) {
    return fetch(raizTienda + ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw d;
        return d;
      });
    });
  }

  function leerCarrito() {
    return fetch(raizTienda + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Deja el carrito con 0 o 1 regalo según corresponda. Devuelve true si cambió algo.
  var enCurso = null;
  function revisar() {
    if (enCurso) return enCurso;
    enCurso = leerCarrito()
      .then(function (cart) {
        // Si hay que dejar uno, primero el que tiene la nota del regalo (queda en el pedido).
        var regalos = cart.items.filter(esRegalo).sort(function (a, b) {
          var na = a.properties && a.properties[cfg.propiedad] != null ? 0 : 1;
          var nb = b.properties && b.properties[cfg.propiedad] != null ? 0 : 1;
          return na - nb;
        });
        var tengo = regalos.reduce(function (a, i) { return a + i.quantity; }, 0);
        var quiero = califica(contarLlaveros(cart)) ? 1 : 0;
        if (tengo === quiero) return false;

        if (quiero === 0 || tengo > 1) {
          var updates = {};
          regalos.forEach(function (i, k) { updates[i.key] = quiero === 1 && k === 0 ? 1 : 0; });
          return post('cart/update.js', { updates: updates }).then(function () { return true; });
        }
        return post('cart/add.js', { items: [lineaRegalo()] }).then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (cambio) { enCurso = null; return cambio; });
    return enCurso;
  }

  // Vuelve a pintar el carrito después de corregir el regalo.
  function refrescar() {
    var enPaginaCarrito = /\/cart\/?$/.test(window.location.pathname);
    if (enPaginaCarrito) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer-items');
    if (drawer && typeof drawer.onCartUpdate === 'function') {
      drawer.onCartUpdate().then(marcarLineas);
    }
    // Burbujas con la cantidad del carrito (header de Dawn y rx-header)
    leerCarrito().then(function (cart) {
      document.querySelectorAll('.rx-header__burbuja').forEach(function (b) { b.textContent = cart.item_count; });
    });
    fetch(raizTienda + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var burbuja = document.getElementById('cart-icon-bubble');
        if (!burbuja || !s['cart-icon-bubble']) return;
        var html = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (html) burbuja.innerHTML = html.innerHTML;
      })
      .catch(function () {});
  }

  // Precio del regalo: valor tachado + "Gratis" (en lugar de $0).
  function pintarGratis(el, conTachado) {
    if (!el || el.dataset.rxGratis) return;
    el.dataset.rxGratis = '1';
    el.textContent = '';
    if (conTachado && cfg.valor) {
      var s = document.createElement('s');
      s.className = 'rx-regalo-tachado';
      s.textContent = cfg.valor;
      el.appendChild(s);
    }
    var g = document.createElement('span');
    g.className = 'rx-regalo-gratis';
    g.textContent = cfg.gratis;
    el.appendChild(g);
  }

  // Carrito de Dawn (página o drawer): la línea del regalo no muestra selector de cantidad
  // ni botón de borrar, y el precio dice "Gratis".
  function marcarLineas() {
    document.querySelectorAll('[data-quantity-variant-id="' + cfg.variante + '"]').forEach(function (input) {
      var linea = input.closest('.cart-item');
      if (!linea || linea.classList.contains('rx-regalo-linea')) return;
      linea.classList.add('rx-regalo-linea');
      linea.querySelectorAll('.cart-item__price-wrapper .price, .cart-item__totals .price').forEach(function (p, k) {
        pintarGratis(p, k === 0);
      });
      if (cfg.chip) {
        var lugar = linea.querySelector('.cart-item__quantity-wrapper') || input.parentNode;
        var chip = document.createElement('span');
        chip.className = 'rx-regalo-chip';
        chip.textContent = cfg.chip;
        lugar.appendChild(chip);
      }
    });
  }

  // Carrito propio de la tienda (#raihue-cart, en templates/cart.json): las líneas solo
  // tienen su número; cuáles son del regalo lo calcula el snippet al armar la página (cfg.lineas).
  function marcarCarritoPropio(lineas) {
    var carrito = document.getElementById('raihue-cart');
    if (!carrito) return;
    (lineas || []).forEach(function (n) {
      var fila = carrito.querySelector('[data-cart-line="' + n + '"]');
      if (!fila || fila.classList.contains('rx-regalo-linea')) return;
      fila.classList.add('rx-regalo-linea');
      // Precio unitario: el tachado ya lo pone el carrito (precio de comparación); el $0 pasa a "Gratis".
      var actual = fila.querySelector('.rh-current');
      if (actual) pintarGratis(actual, !fila.querySelector('.rh-old'));
      pintarGratis(fila.querySelector('.rh-line-total'), true);
      var titulo = fila.querySelector('.rh-item-title');
      if (titulo) {
        var nota = document.createElement('div');
        nota.className = 'rh-variant';
        nota.textContent = cfg.propiedad + ': ' + cfg.nota;
        titulo.insertAdjacentElement('afterend', nota);
      }
      var acciones = fila.querySelector('.rh-item-actions');
      if (acciones && cfg.chip) {
        var chip = document.createElement('span');
        chip.className = 'rx-regalo-chip';
        chip.textContent = cfg.chip;
        acciones.appendChild(chip);
      }
    });
  }

  window.RxRegalo = {
    cfg: cfg,
    califica: califica,
    lineaRegalo: lineaRegalo,
    leerCarrito: leerCarrito,
    esRegalo: esRegalo,
    revisar: revisar
  };

  // Cambios de cantidad en el carrito (página o drawer de Dawn)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      revisar().then(function (cambio) { if (cambio) refrescar(); });
      setTimeout(marcarLineas, 400);
    });
  }

  // El carrito se vuelve a pintar seguido: marcamos la línea del regalo cada vez.
  var pendiente;
  new MutationObserver(function () {
    clearTimeout(pendiente);
    pendiente = setTimeout(marcarLineas, 60);
  }).observe(document.body, { childList: true, subtree: true });
  marcarLineas();

  // Si al cargar la página el carrito quedó desparejo, lo corregimos
  // (con el carrito atenuado mientras tanto, para que no se vea el estado viejo).
  if (cfg.revisar) {
    document.documentElement.classList.add('rx-regalo-corrigiendo');
    revisar().then(function (cambio) {
      if (cambio) { refrescar(); return; }
      document.documentElement.classList.remove('rx-regalo-corrigiendo');
    });
  } else {
    marcarCarritoPropio(cfg.lineas);
  }
})();
